import React from 'react';
import { useNavigate } from 'react-router-dom';
import { PathsEnum } from '@routes/enumerators/paths.enum';
import { RequestPageOutlined, PendingActionsOutlined, BeachAccessOutlined, AssignmentOutlined, VolunteerActivismOutlined, SellOutlined } from '@mui/icons-material';
import { Button, Typography } from '@mui/material';

interface CardMenuHomeProps {
	route: PathsEnum | string;
	title: string;
	disabled?: boolean;
}

export function CardMenuHome({
	route,
	title,
	disabled = false
}: CardMenuHomeProps) {
	const navigate = useNavigate();

	const styleIcons = {
		fontSize: '1.35rem',
		color: disabled ? 'rgba(0, 0, 0, 0.26)' : '#FF00FF'
	}
	return (
		<Button
			sx={{
				textTransform: 'none',
				marginTop: '1rem',
				paddingLeft: '1rem',
				alignItems: 'center',
				justifyContent: 'start',
				display: 'flex',
				flexDirection: 'row',
				borderRadius: '8px',
				width: '100%',
				height: '3.8rem',
				backgroundColor: '#eeeeee',
				'&:hover': {
					backgroundColor: 'lightgray',
				},
			}}
			onClick={() => navigate(route)}
			disabled={disabled}
		>
			{
				title === 'Demonstrativo de pagamentos' ? <RequestPageOutlined style={styleIcons} /> :
					title === 'Banco de horas' ? <PendingActionsOutlined style={styleIcons} /> :
						title === 'Férias' ? <BeachAccessOutlined style={styleIcons} /> :
							title === 'Informe de rendimentos' ? <AssignmentOutlined style={styleIcons} /> :
								title === 'Benefícios' ? <VolunteerActivismOutlined style={styleIcons} /> :
									title === 'Performance de Produto' ? <SellOutlined style={styleIcons} /> :
										title === 'Busca por Imagem' ? <SellOutlined style={styleIcons} /> : null
			}
			<Typography sx={{ marginLeft: '0.8rem', fontWeight: 'bold', fontSize: '0.8rem' }}>{title}</Typography>
		</Button>
	)
}